"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalysisTypeSchema = exports.AnalysisType = void 0;
const zod_1 = require("zod");
var AnalysisType;
(function (AnalysisType) {
    AnalysisType["Pinout"] = "pinout";
    AnalysisType["ComponentValues"] = "componentValues";
})(AnalysisType || (exports.AnalysisType = AnalysisType = {}));
exports.AnalysisTypeSchema = zod_1.z.nativeEnum(AnalysisType);
//# sourceMappingURL=analysis-type.js.map